<template>
  <section>
    <h4 class="mb-2">Informações Complementares</h4>    
    <v-form ref="form" lazy-validation @submit.prevent="save" v-if="!disabled">
      <div v-for="field in document.document_fields" :key="field.code">        
        <v-text-field    
          v-if="field.kind === 'date'"   
          v-mask="['##/##/####']"
          placeholder="DD/MM/AAAA"
          v-model="field.value"          
          :label="`${field.name} *`"
          :rules="[rules.required]"
          outlined
          dense                    
          color="success"
          :disabled="isLoading || disabled"          
        />
        <v-text-field  
          v-else     
          v-model="field.value"          
          :label="`${field.name} *`"
          :rules="[rules.required]"
          outlined
          dense                    
          color="success"
          :disabled="isLoading || disabled"
        />
      </div> 
      <v-btn depressed color="success" type="submit" :disabled="isLoading || disabled">
        Salvar
      </v-btn>  
    </v-form>
    
    <section v-else>
      <div v-for="field in document.document_fields" :key="field.code" class="mb-3">
        <strong>{{ field.name }}: </strong> {{ field.value || '-' }}        
      </div>
    </section>
  </section>
</template>

<script>
  import DocumentService from '@/services/documento.service';
  import GlobalStore from '@/store/modules/global';

  export default {
    name: 'OrderDocumentInfoComplementary',  

    props: {      
      document: {
        type: Object,
        required: true
      },

      disabled: {
        type: Boolean,
        required: false,
        default: false
      }
    },  

    data: () => ({
      isLoading: false,

      rules: {
        required: value => !!value || 'Esse campo deve ser preenchido',
      },
    }),

    methods: {
      save() {
        const isValid = this.$refs.form.validate();
        if (!isValid) return;

        this.isLoading = true;
        const body = {
          fields: this.document.document_fields.map(field => ({
            id: field.id,
            value: field.value
          }))
        };

        DocumentService.update(this.document.id, body)
          .subscribe({
            next: () => {
              this.isLoading = false;
              GlobalStore.setSnackBar({
                show: true,
                message: 'Informações complementares salvas com sucesso.',
                type: 'success'
              });
            },
            error: () => {
              this.isLoading = false;
            }
          });
      }
    },
  }
</script>
